<div class="containerCambioViaPago">
  <div class="wrapper">
    <ng-container *ngIf="showStepper"> 
    <button type="button" class="btn-back" fill="clear" (click)="goBack()">
      <ion-icon name="arrow-back-outline"></ion-icon>
      <span>Volver</span>
    </button>
    <div class="stepper-section">
      <app-stepper></app-stepper>
    </div>
    </ng-container>
    <div class="content-section">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
